import { toolColors } from './room-colors'
// Flat Math.max comparator: aligned input rows, a first-row output, and real values.
export function drawMaxSlots(game,building){
  const c=game.c,rows=building.rows||1,color=toolColors('Math.max');c.save()
  if(rows>1||building.variant?.startsWith('numbers-')){if(building.dir===2)c.scale(-1,1)}
  else c.rotate(building.dir*Math.PI/2)
  for(let row=0;row<rows;row++)game.rect(-29,row*56-16,8,32,color.ink,2)
  game.rect(21,-16,8,32,color.ink,2);c.restore()
}
export function drawMaxCabinet(game,building){
  const c=game.c,rows=building.rows||1,bottom=(rows-1)*56+27,color=toolColors('Math.max')
  game.rect(-21,-27,42,bottom+27,building.error?'#a67478':color.primary,3,color.border)
  const batch=building.visualBatch,pending=!batch&&building.inputs&&building.inputs.some(Boolean)
  for(let row=0;row<rows;row++){
    const cy=row*56,item=pending?building.inputs[row]:null
    const value=item?item.value:pending?undefined:batch?.values[row]
    if(row>0){c.beginPath();c.moveTo(-21,cy-28);c.lineTo(21,cy-28);c.strokeStyle=color.border;c.lineWidth=1;c.stroke()}
    if(value===undefined){game.rect(-4,cy-1,8,2,color.card,1);continue}
    const content=typeof value==='string'?value:JSON.stringify(value),text=content??String(value),layout=game.fittedMaterialText(text,34,27)
    const font=layout.lines.length===1&&text.length<=2?20:layout.font
    c.save();c.beginPath();c.rect(-18,cy-13,36,28);c.clip()
    const top=cy-(layout.lines.length-1)*layout.lineHeight/2
    layout.lines.forEach((line,index)=>game.text(line,0,top+index*layout.lineHeight,font,'#ffffff','center',600))
    c.restore()
    if(!pending&&batch){
      const win=Number(value)===batch.result,markY=cy+8
      c.strokeStyle=win?'#43d51a':'#ec302b';c.lineWidth=3;c.lineCap='round';c.lineJoin='round';c.beginPath()
      if(win){c.moveTo(7,markY);c.lineTo(11,markY+4);c.lineTo(18,markY-4)}
      else{c.moveTo(9,markY-4);c.lineTo(17,markY+4);c.moveTo(17,markY-4);c.lineTo(9,markY+4)}
      c.stroke()
    }
  }
  for(const control of maxControls(building)){
    const cx=control.x+control.w/2,cy=control.y+control.h/2
    game.rect(control.x,control.y,control.w,control.h,color.ink,2)
    game.rect(cx-3,cy-.75,6,1.5,color.card,.4)
    if(control.delta>0)game.rect(cx-.75,cy-3,1.5,6,color.card,.4)
  }
}
export function maxControls(building){
  if(building.type!=='Math.max'||!building.variant?.startsWith('numbers-'))return []
  const rows=building.rows||1,y=(rows-1)*56+14,controls=[]
  if(rows<64)controls.push({delta:1,x:-21,y,w:21,h:12})
  if(rows>2)controls.push({delta:-1,x:0,y,w:21,h:12})
  return controls
}
